import React from 'react';
import TitleBase from './TitleBase';
import { TTitle } from './types';

const Title4 = ({ as = 'h4', ...rest }: TTitle) => <TitleBase {...rest} as={as} kind="title-4" />;

export default Title4;
